import { Link } from "react-router-dom";

const FooterFull = () => {
    return (
        <div id="footer_home">
            <div className="widthfix">
                <div className="footer_blk">
                    <div className="footerInpage">
                        Moham Uttarana Pvt Ltd &copy; {new Date().getFullYear()} | All rights reserved.
                    </div>
                </div>

                <div className="footer_blk">
                    <div className="footerInpage">
                        <Link to="/privacy-policy">Privacy Policy</Link> | <Link to="/terms-of-use">Terms of Use</Link>
                    </div>
                </div>

                <div className="footer_blk">
                    <div className="footerInpage">
                        <Link to="/contact-us">Contact Us</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

const FooterSmall = () => {
    return (
        <div id="footer">
            <div className="footer_blk">
                <div className="widthfix">
                    <div className="footerInpage">
                    Moham Uttarana Pvt Ltd &copy; {new Date().getFullYear()} | All rights reserved.
                    </div>
                </div>
            </div>
        </div>
    );
}

const Component = ({ type }) => {
    return type ? <FooterFull /> : <FooterSmall />
};

export default Component;